import React from "react";
var __jsx = React.createElement;
import stl from './TrackingReturnSection.module.css';
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { Alert } from "@componentsShared/Alert";
// @ts-ignore

import { useMemo } from "react";
var TrackingReturnStatusSection = function TrackingReturnStatusSection(_ref) {
  var details = _ref.details;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var completion_type = useMemo(function () {
    var _details$return_order;
    return details === null || details === void 0 ? void 0 : (_details$return_order = details.return_order_data) === null || _details$return_order === void 0 ? void 0 : _details$return_order.completion_type;
  }, [details]);
  var status = useMemo(function () {
    var _details$return_order2;
    return details === null || details === void 0 ? void 0 : (_details$return_order2 = details.return_order_data) === null || _details$return_order2 === void 0 ? void 0 : _details$return_order2.status;
  }, [details]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.trackingReturnSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imageBox
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.image,
    src: CDN_LINK + '/assets/images/tracking-details/guarantee.svg',
    alt: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.titleBox
  }, /*#__PURE__*/React.createElement("h4", {
    className: stl.title
  }, t("track_status_car_return", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.description
  }, t("return_request_status_shared_here", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.statusContainer
  }, completion_type !== undefined && /*#__PURE__*/React.createElement(Alert, {
    variant: {
      0: "info",
      1: "success",
      2: "danger",
      3: "danger",
      4: "success"
    }[completion_type],
    message: status,
    note: {
      1: details.return_order_data.return_date
    }[completion_type]
  }))));
};
export default TrackingReturnStatusSection;